module.exports = __webpack_public_path__ + "img/info.002.0149b0fa.jpeg";